import React, { Component, useId, useRef } from "react";
import "./checkNumberDetils.scss";
import { Toast, WhiteSpace, WingBlank, Button, Tag } from "antd-mobile";
import axios from "../axios";
import { Item } from "antd-mobile/lib/tab-bar";
import html2canvas from "html2canvas";


var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

class checkNumberDetils extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            cateId : "",
            numType : "",
            number : "",
            prefix : "",
            cateType: "",
            marketId : "", //行情Id
            marketTag : "",//行情tag
            numberText : "",//号码显示的名称 如"J433535-554 20连号"
            shareInfo : "",
            shareTitle : "",
            title: "",
            segmentStatsInfo :[],
            numberInfo : [],
            bgLogoArray : [],
            imageData : '',
            showImage : false,
            saveimgPrompt : "保存图片",
            resultId : '',
            aiReferPrice : '',
        };
        
    }

    getUrlParam = (name) => {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = this.props.location.search.substr(1).match(reg);
        if (r != null) {
          return decodeURI(r[2]);
        }
        return ""; //如果此处只写return;则返回的是undefined
    };

    appLoginUserData = (val) => {//登录回调
        if (val) {
            var userId = "", tokenHead = "",tokenCode="";
            var userArray = val.split("&");
            for (let i = 0; i < userArray.length; i++) {
                const element = userArray[i];
                if (element.includes('userId')) {
                    let dataArray = element.split("=");
                     userId = dataArray[dataArray.length - 1];
                }else if (element.includes('tokenHead')) {
                    let dataArray = element.split("=");
                     tokenHead = dataArray[dataArray.length - 1];
                }else if (element.includes('tokenCode')) {
                    let dataArray = element.split("=");
                     tokenCode = dataArray[dataArray.length - 1];
                }
            }
    
            if (tokenHead.length > 0 && tokenCode.length > 0) {
                sessionStorage.setItem("Authorization",tokenHead+' '+tokenCode);
            }
            if (userId.length > 0) {
                sessionStorage.setItem("YBUserId",userId);
                //请求数据
                this.addReloadData();
            }   
        }
    };

    addShareContent = () => {
        let shareUrl = window.location.href.split('?')[0] + "?cateId=" + this.state.cateId + "&prefix=" +this.state.prefix + "&numType=" + this.state.numType + "&number=" + this.state.number + "&cateType=" + this.state.cateType + "&v=" + this.getUrlParam("v");
        var shareInfo = {
            shareUrl : shareUrl,
            shareTitle : this.state.shareTitle,
            shareDesc : this.state.shareInfo,
        }
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativeShareContent.postMessage(shareInfo);
                } catch (e) {
                }
            }else{
                try {
                    window.app.androidNativeShareContent(JSON.stringify(shareInfo));
                } catch (e) {
                }
            }
        }
    };

    componentDidMount () {
        
        sessionStorage.setItem("cAppVersion",this.getUrlParam('v'));
        if (this.getUrlParam('userId').length > 0) {
            sessionStorage.setItem("YBUserId",this.getUrlParam('userId'));
        }
        //请求数据
        this.addReloadData();

        // funcitonName 是原生回调使用的方法名
        window["appLoginUserData"] = this.appLoginUserData.bind(this);

    };

    addReloadData = () =>{
        let cateId = this.getUrlParam('cateId');
        let numType = this.getUrlParam('numType');
        let number = this.getUrlParam('number');
        let prefix = this.getUrlParam('prefix');
        let cateType = this.getUrlParam('cateType');
        let userId = "";
        if (sessionStorage.getItem('YBUserId')) {
            userId = sessionStorage.getItem('YBUserId');
        }
        const _this = this;
        axios
         .post("fbusiness/json/queryNumber",{userId : userId, cateId : cateId, numType : numType, number : number, prefix : prefix})
         .then(function (response){
            if (response.data.code === 10000) {
                let resultObject = response.data.resultObject;
                let resultId = resultObject.resultId;
                var segmentStatsInfo = [];
                var numberInfo = [];
                var bgLogoArray = [];
                if (!(resultObject.numberInfo ===null)) {
                    if (!(Object.keys(resultObject.numberInfo).length ===0)) {
                        var i =1;
                        for (let key in resultObject.numberInfo) {
                            var numberNameArray = [];
                            if(!(resultObject.numberInfo[key] === null)){
                                numberNameArray = resultObject.numberInfo[key];
                            }
                            var numberDict = { "serialNumber" : i, "numberTitle" : key, "numberNames" : numberNameArray};
                            numberInfo.splice(i-1,0,numberDict);
                            if (i%4 === 0) {
                                bgLogoArray.splice(0,0,"1");
                            }
                            i++;
                        }
                    }
                } 
                

                if (!(resultObject.segmentStatsInfo === null)) {
                    if (!(Object.keys(resultObject.segmentStatsInfo).length ===0)) {
                        var i =1;
                        for (let key in resultObject.segmentStatsInfo) {
                            var segmentStatsDict = resultObject.segmentStatsInfo[key];
                            var numberNames = "";
                            if (!(segmentStatsDict ===null)) {
                                if (!(Object.keys(segmentStatsDict).length ===0)) {
                                    for (let key in segmentStatsDict) {
                                        let value = segmentStatsDict[key];
                                        numberNames = numberNames.concat(key + value + "张" + " ");
                                    }
                                }
                            }
                            var numberDict = {"numberTitle" : key, "numberNames" : numberNames};
                            segmentStatsInfo.splice(i-1,0,numberDict);
                            if (i%4 === 0) {
                                bgLogoArray.splice(0,0,"1");
                            }
                            i++;
                        }
                    }
                }

                _this.setState({
                    cateId : cateId,
                    numType : numType,
                    number : number,
                    prefix : prefix,
                    cateType : cateType,
                    resultObject : resultObject ,
                    marketId : resultObject.marketId,
                    marketTag : cateType,
                    numberText : resultObject.numberText,
                    title : resultObject.title,
                    shareTitle : resultObject.shareTitle,
                    shareInfo : resultObject.shareInfo,
                    numberInfo : numberInfo,
                    segmentStatsInfo : segmentStatsInfo,
                    bgLogoArray : bgLogoArray,
                    resultId : resultId,
                    aiReferPrice : '',
                })

            }else {
               let message = response.data.message;
               Toast.show(message, 2);
            }

            _this.addShareContent();
         })
         .catch(function (error) {
            console.log(error);
         });
    };

    gotoButtonBack = ()=>{ 
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (window.history.length >1) {
                this.props.history.goBack();
                return;
            }
        }
        
        this.props.history.push(`./checkNumber?v=${this.getUrlParam('v')}`);
         
    };

    copyAllContent = () =>{//复制内容

        var copyAllContent = "名称：" + this.state.title + this.state.numberText + "\n" + "冠号版别：" + this.state.shareInfo + "\n";
        if (this.state.numberInfo.length > 0) {
            this.state.numberInfo.map(item =>{
                let number = item["numberTitle"] + ": ";
                var names = "";
                if (item.numberNames.length > 0) {
                    item.numberNames.map(item => {
                        names = names.concat(item.title," ");
                    });
                }
                copyAllContent = copyAllContent.concat(number,names,"\n");
            });
        }else if (this.state.segmentStatsInfo.length > 0) {
            this.state.segmentStatsInfo.map(item =>{
                copyAllContent = copyAllContent.concat(item.numberTitle,": ",item.numberNames,"\n");
            });
        } 

        if (window.isSecureContext) {
            navigator.clipboard.writeText(copyAllContent)
            .then(function () {
                Toast.show("内容已复制到剪贴板", 2);
            })
            .catch(function(err) {
                Toast.show(err, 2);
             });
        } else {
            Toast.show("环境不安全禁止复制内容", 2);
        }
    }

    saveWindowImage = ()=>{//保存图片

        this.setState({
            saveimgPrompt : "正在生成图片",
        })
        const captureElement = document.getElementById('checkNumberDetils');
        var element = document.getElementById("allContentData_divid");
        var yPosition = 0;
        while (element) {
            yPosition += element.offsetTop;
            element = element.offsetParent;
        }
        yPosition += window.scrollY;
    
        const copyDom = captureElement.cloneNode(true);
        copyDom.style.width = window.innerWidth; // 自适应宽度
        copyDom.style.height =`${captureElement.scrollHeight}px`; // 覆盖滚动高度
        document.body.appendChild(copyDom);

        const options = {
            scale: window.devicePixelRatio, // 高清缩放
            width: window.innerWidth,
            height: yPosition,
            useCORS: true, // 解决跨域资源问题
        };
        
        html2canvas(copyDom, options).then(canvas => {
            let imgData = canvas.toDataURL('image/png' , 0.3);
            document.body.removeChild(copyDom);
            var ua = navigator.userAgent.toLowerCase();
            var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
            let imageData = imgData.substring(imgData.indexOf(',') + 1);
            if (isApp) {
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeSaveImage.postMessage({"imageData" : imageData});
                    } catch (e) {
                    }
                }else{
                    try {
                        window.app.androidNativeSaveImage(imageData);
                    } catch (e) {
                    }
                }
            }
            this.setState({
                imageData : imgData,
                showImage : true,
                saveimgPrompt : "保存图片",
            });
        });
    }

    /**去AI估价*/
    gotoAIValuation = function () {
        let userId = "";
        if (sessionStorage.getItem('YBUserId')) {
            userId = sessionStorage.getItem('YBUserId');
        }
        if (userId.length < 1) {//未登录去登录
            var ua = navigator.userAgent.toLowerCase();
            var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
            if (isApp) {
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeLogin.postMessage('');
                    } catch(e){
                        setTimeout(function () {
                            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                        }, 2000);
                    }
                    
                } else {
                    try {
                        window.app.login();
                    } catch (e) {
                        setTimeout(function () {
                            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                        }, 2000);
                    }
                }
            }else{
                this.
                window.open('http://app.youbao360.com/h5/download.html?serverFlag=','_blank');
            }
            return;
        }
        
        let resultId = this.state.resultId;
        const _this = this;
        axios
        .post("trade/json/toSmartEvaluateNumberValue",{userId : userId, recId : resultId,})
        .then(function (response){
            if (response.data.code === 10000) {
                let resultObject = response.data.resultObject;
                var aiTitle = resultObject.title;
                var aiText = resultObject.text;
                var referPrice = resultObject.referPrice;

                _this.setState({
                    aiTitle : aiTitle,
                    aiText : aiText,
                    aiReferPrice : referPrice,
                })

            }else {
            let message = response.data.message;
            Toast.show(message, 2);
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    gotoAppIssue = () => {
        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";

        if (isApp) {

            const captureElement = document.getElementById('checkNumberDetils');
            var element = document.getElementById("allContentData_divid");
            var yPosition = 0;
            while (element) {
                yPosition += element.offsetTop;
                element = element.offsetParent;
            }
            yPosition += window.scrollY;
        
            const copyDom = captureElement.cloneNode(true);
            copyDom.style.width = window.innerWidth; // 自适应宽度
            copyDom.style.height =`${captureElement.scrollHeight}px`; // 覆盖滚动高度
            document.body.appendChild(copyDom);

            const options = {
                scale: window.devicePixelRatio, // 高清缩放
                width: window.innerWidth,
                height: yPosition,
                useCORS: true, // 解决跨域资源问题
            };

            html2canvas(copyDom, options).then(canvas => {
                // 转换为图片并保存
                const imgDatabase64 = canvas.toDataURL('image/png');
                let imageData = imgDatabase64.substring(imgDatabase64.indexOf(',') + 1);
                document.body.removeChild(copyDom);
                var resultObject =  this.state.resultObject;
                var releaseDict = {};
                releaseDict.cateCode = resultObject.cateCode;
                releaseDict.cateName = resultObject.cateName;
                releaseDict.marketName = resultObject.marketName;
                releaseDict.marketId = resultObject.marketId;
                releaseDict.dealCnt = resultObject.dealCnt;
                releaseDict.unitName = resultObject.unitName;
                releaseDict.desc = resultObject.shareTitle;
                releaseDict.marketTag = this.state.marketTag;
                releaseDict.imageData = imageData;
                releaseDict.price = '';
                if (isiOS) {
                    try {
                        window.webkit.messageHandlers.IOSNativeIssue.postMessage(releaseDict);
                    } catch (e) {
                        setTimeout(function () {
                            Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                        }, 2000);
                    }
                }else{
                    if (this.addAppVersionConvertString() == true){//3.5.2以上版本
                        try {
                            window.app.androidNativeIssue(JSON.stringify(releaseDict));
                        } catch (e) {
                            setTimeout(function () {
                                Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                            }, 2000);
                        }
                    }else{//3.5.1以下版本
                        try {
                            window.app.androidNativeIssue();
                        } catch (e) {
                            setTimeout(function () {
                                Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                            }, 2000);
                        }
                    } 
                }     
            });
        }else{
            window.open('http://app.youbao360.com/h5/download.html?serverFlag=','_blank');
        }
    };

    /**跳转到行情详情 */
    gotoAppMarket = () => {

        var marketDict = {
            oid : this.state.marketId,
            code : "",
            tag : this.state.marketTag,
          };

        var ua = navigator.userAgent.toLowerCase();
        var isApp = ua.match(/youbaoapploadinghtml/i) == "youbaoapploadinghtml";
        if (isApp) {
            if (isiOS) {
                try {
                    window.webkit.messageHandlers.IOSNativeMarket.postMessage(marketDict);
                } catch (e) {
                    setTimeout(function () {
                        Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                    }, 2000);
                }
            }else{
                try {
                    window.app.androidNativeMarket(JSON.stringify(marketDict));
                } catch (e) {
                    setTimeout(function () {
                        Toast.fail("请升级最新版本,当前版本过低暂不支持此功能", 3);
                    }, 2000);
                }
            }
        }else{
            window.open('http://app.youbao360.com/h5/download.html?serverFlag=','_blank');
        }
    };

    addAppVersionConvertString = () =>{
        var appVersion =  sessionStorage.getItem("cAppVersion");
        if (appVersion) {
            var appVersions = appVersion.split(".");
            var appVersionStr = "";
            for (let i = 0; i < appVersions.length; i++) {
                const element = appVersions[i];
                appVersionStr = appVersionStr.concat(element);
            }
            if  (parseInt(appVersionStr) > 351) {
                return true;
            }else{
                return false;
            }
        }   
    };

    render () {
        return (
            <div id="checkNumberDetils" className="checkNumberDetils_diV">

                {this.state.showImage ? 
                    <div className="dialogModal" onClick={() =>{this.setState({showImage : false,imageData :''})}}> 
                        <img id="jiepingImage" className="saveImage" src={this.state.imageData}></img>
                        {/* <p className="prompt_p">提示：长按图片选择「保存」</p> */}
                    </div>
                : null}
                
                <button className="gotoButton" onClick={() =>this.gotoButtonBack()}>我要查询</button>
                <header className="header">
                    <img src = "http://image.ybk008.com/checkNumberheader.png" />
                </header>

                {this.state.title.length > 0 ?
                    <div className="allContentData_div">
                        <div className="centerWhite_div">
                            <div className="centerBorderLine_div">
                                <div className="listContent_div listContent_bg_div">
                                    <button className="name_button"> 名称</button>
                                    <button className="content_button"> {this.state.title}{this.state.numberText}</button>
                                </div>
                                <div className="listContent_div">
                                    <button className="name_button">冠号版别 </button>
                                    <button className="content_button"> {this.state.shareInfo}</button>
                                </div>
                                {this.state.aiReferPrice.length ?
                                    <div className="listContent_div listContent_bg_div">
                                        <button className="name_button">参考总估价 </button>
                                        <button className="content_button"> {this.state.aiReferPrice}</button>
                                    </div>
                                : null}
                            </div>   
                        </div>
                        {(this.state.resultId.length > 0 && this.state.aiReferPrice.length <1) ? 
                            <div className="aiContent_div">
                                <img className="ai_Image" src="http://image.ybk008.com/checkNumberAI.png"></img>
                                <button className="gotoAIPrice" onClick={() =>this.gotoAIValuation()} >AI免费估价</button>
                            </div>
                        : null}
                    </div>
                : null}


                <div className="seat_div"></div>

                {this.state.segmentStatsInfo.length > 0 && (
                    <div className="allContentData_div">
                        <div className="centerWhite_div">
                            {this.state.segmentStatsInfo.map((item, key) => (
                                <div key={key + 10000} className="centerWhiteLine_div">
                                    <div className="seat_div"></div>
                                    <div className="centerBorderLine_div">
                                        <div className="listContent_div listContent_bg_div">
                                            <button className="name_button"> 冠号</button>
                                            <button className="content_button"> {item.numberTitle}</button>
                                        </div>
                                        <div className="listContent_div">
                                            <button className="name_button">冠号版别 </button>
                                            <button className="content_button"> {item.numberNames}</button>
                                            {(key % 2 ===0) ?
                                                <div className="logoImageAll_div"> 
                                                    <img className="bglogo_img" src={require("../assets/youbaoAPPbj.png")}></img>
                                                </div>
                                            :null}
                                        </div>
                                    </div>
                                </div>  
                            ))}
                        </div>
                    </div>
                )}

                {this.state.numberInfo.length > 0 && (
                    <div className="allContentData_div">
                        <div className="centerWhite_div">
                            <div className="imageContent_div">
                                <img src = {require("../assets/mxtsimage.png")} ></img>
                            </div>

                            <div className="centerBorderLine_div">

                                <div className="listContent_div listContent_bg_div">
                                    <button className="serialNumber_button"> 序号</button>
                                    <button className="number_button"> 冠号 </button>
                                    <div className="numberName_div">
                                        <button className="numberName_button"> 名称 </button>
                                    </div>    
                                </div>
                                {this.state.numberInfo.map((item, key) => (
                                    <div key={key + 20000} className="listContent_div">
                                        <button className="serialNumber_button"> {item.serialNumber}</button>
                                        <button className="number_button"> {item.numberTitle}</button>
                                        <div className="numberName_div">
                                            {item.numberNames.map((itemName,keyId) => (
                                                <button key={keyId + 30000} className="numberName_button">{itemName.title}</button>
                                            ))}
                                        </div>
                                        {((item.serialNumber % 5 ===0)|| (item.serialNumber === 1)) ? 
                                            <div className="logoImageAll_div"> 
                                                <img className="bglogo_img" src={require("../assets/youbaoAPPbj.png")}></img>
                                            </div>
                                        :null}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                <div className="seat_div"></div>

                <div id="allContentData_divid" className="allContentData_div">
                    <div className="centerWhite_div centerWhite_div2">
                        <div className="lookHangQing_div">
                            <img className="hangqing_img" src = "http://image.ybk008.com/YBCheckNumberMarketBanner.png" onClick={() =>this.gotoAppMarket()}></img>
                            <p className="hangqingtitle_p">{this.state.title}</p>
                        </div>
                    </div>
                </div>

                <div className="introduction_div">
                    <p className="introduction_p">上邮宝交易  放心又安全</p>
                    <p className="introduction_p introduction_p2">北京风暴迅达科技有限公司  京ICP备19055597号-7A</p>
                </div>

                <footer className="footerview">
                    <div className="footerButton_div">
                        <button className="releaseButton" onClick={() =>this.gotoAppIssue()}>发布去卖</button>  
                    </div>
                    <div className="footerButton_div2">
                        {/* <button className="copyContentButton" onClick={() =>this.copyAllContent()}>复制内容</button> */}
                        <button id="saveImageButton" className="saveImageButton" onClick={() =>this.saveWindowImage() }>{this.state.saveimgPrompt}</button>
                    </div>
                </footer>
               
            </div>    
        );
    }

}

export default checkNumberDetils;